import { CrossClientQueryAtomicClause } from '../../../models/CrossClient'
import React from 'react'

export interface CrossClientClausesProps {
  atomicClauses: CrossClientQueryAtomicClause[]
}
export const CrossClientClauses: React.FC<CrossClientClausesProps> = ({ atomicClauses }) => {
  return (
    <div className='d-flex flex-column gap-2'>
      {atomicClauses.map((clause, index) => (
        <div key={index} className='d-flex gap-2 align-items-center py-2 zocks-px-0.75 zocks-border-0.5 zocks-bg-color-gray-200'>
          <i className='bi bi-diamond zocks-text-info fs-6' />
          <div className='paragraph-small medium'>{clause.description}</div>
        </div>
      ))}
    </div>
  )
}
